export type DailyTagDuration = "FULL" | "HALF" | "NONE";

export function durationAsNbDays(dtd: DailyTagDuration): number {
  switch (dtd) {
    case "FULL":
      return 1;
    case "HALF":
      return 0.5;
    case "NONE":
      return 0;
  }
}
